import type { MisconceptionDefinition } from '../types'

export const euLandMisconceptions: MisconceptionDefinition[] = [
  // ───────────────────────────────────────────────────────────
  // TOPO-EU-LAND — landvormen en regio's van Europa
  // ───────────────────────────────────────────────────────────
  {
    id: 'topo.land-iberisch-vs-apennijns',
    label: 'Iberisch ↔ Apennijns Schiereiland verward',
    module: 'Topo',
    description:
      'Leerling verwart het Iberisch Schiereiland (Spanje/Portugal) met het Apennijns Schiereiland (Italië, de laars).',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.land-grillige-kust-vs-laars',
    label: 'Grillige kust ↔ laarsvorm verward',
    module: 'Topo',
    description:
      'Leerling verwart de grillige kustlijn met veel eilanden (Griekenland) met de laarsvorm van Italië.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.land-adriatisch-vs-laars',
    label: 'Adriatische kust ↔ laarsvorm verward',
    module: 'Topo',
    description:
      'Leerling verwart de gebogen kustlijn van Kroatië aan de Adriatische Zee met de laarsvorm van Italië.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  // Q002 — NIET-vraag over buurlanden van Nederland
  {
    id: 'topo.eu-niet-vraag-buurland-oost',
    label: 'NIET-vraag genegeerd, kiest oostelijk buurland',
    module: 'Topo',
    description:
      'Leerling negeert het sleutelwoord "NIET" en kiest Duitsland (een werkelijk buurland in het oosten) als antwoord op de vraag welk land NIET aan Nederland grenst.',
    typicalFamilies: ['TOPO-EU-LAND', 'TOPO-NL-BUURLANDEN'],
  },
  {
    id: 'topo.eu-niet-vraag-buurland-zuid',
    label: 'NIET-vraag genegeerd, kiest zuidelijk buurland',
    module: 'Topo',
    description:
      'Leerling negeert het sleutelwoord "NIET" en kiest België (een werkelijk buurland in het zuiden) als antwoord op de vraag welk land NIET aan Nederland grenst.',
    typicalFamilies: ['TOPO-EU-LAND', 'TOPO-NL-BUURLANDEN'],
  },
  {
    id: 'topo.eu-alle-genoemd-als-buurland',
    label: 'Denkt dat alle genoemde landen buurland zijn',
    module: 'Topo',
    description:
      'Leerling kiest "geen van alle" en gaat ervan uit dat elk in de vraag genoemd land aan Nederland grenst — herkent niet dat Frankrijk geen direct buurland is.',
    typicalFamilies: ['TOPO-EU-LAND', 'TOPO-NL-BUURLANDEN'],
  },
  // Q003 — grootste EU-land qua oppervlakte
  {
    id: 'topo.eu-grootte-spanje-eerst',
    label: 'Verwart Spanje (2e) met Frankrijk (1e) qua oppervlakte',
    module: 'Topo',
    description:
      'Leerling kiest Spanje als grootste EU-land qua oppervlakte; Spanje is wel groot (~505.000 km²) maar Frankrijk is groter (~640.000 km²).',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-grootte-inwoners-vs-opp',
    label: 'Verwart meeste inwoners (Duitsland) met grootste oppervlakte',
    module: 'Topo',
    description:
      'Leerling koppelt "grootste land" aan inwonertal in plaats van aan oppervlakte: Duitsland heeft de meeste inwoners van de EU, maar Frankrijk en Spanje zijn qua oppervlakte groter.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-grootte-italie-overschat',
    label: 'Overschat oppervlakte Italië door herkenbare laarsvorm',
    module: 'Topo',
    description:
      'Leerling overschat de oppervlakte van Italië omdat de laarsvorm visueel opvalt op de kaart; Italië is met ~301.000 km² juist kleiner dan Frankrijk, Spanje en Duitsland.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  // Q004 — Polen in welke regio van Europa
  {
    id: 'topo.eu-regio-polen-in-west',
    label: 'Plaatst Polen in West-Europa i.p.v. Oost-Europa',
    module: 'Topo',
    description:
      'Leerling plaatst Polen in West-Europa; Polen ligt juist ten oosten van Duitsland en hoort dus tot Oost-Europa.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-regio-polen-in-zuid',
    label: 'Plaatst Polen in Zuid-Europa i.p.v. Oost-Europa',
    module: 'Topo',
    description:
      'Leerling plaatst Polen in Zuid-Europa; Zuid-Europa omvat landen rond de Middellandse Zee, terwijl Polen ten oosten van Duitsland ligt.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-regio-polen-in-noord',
    label: 'Plaatst Polen in Noord-Europa i.p.v. Oost-Europa',
    module: 'Topo',
    description:
      'Leerling plaatst Polen in Noord-Europa; Noord-Europa = Scandinavië (Noorwegen, Zweden, Finland, Denemarken), terwijl Polen zuidelijker en oostelijker ligt.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  // Q005 — Iberisch Schiereiland (Spanje + Portugal)
  {
    id: 'topo.eu-schiereiland-frankrijk-iberisch',
    label: 'Denkt dat Frankrijk op het Iberisch Schiereiland ligt',
    module: 'Topo',
    description:
      'Leerling rekent Frankrijk tot het Iberisch Schiereiland en mist dat de Pyreneeën de natuurlijke noordgrens vormen — Frankrijk ligt ten noorden, Spanje ten zuiden.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-schiereiland-italie-iberisch',
    label: 'Verwart Apennijns/Balkan met Iberisch Schiereiland',
    module: 'Topo',
    description:
      'Leerling verwart het Apennijns Schiereiland (Italië) of het Balkanschiereiland (Griekenland) met het Iberisch Schiereiland (Spanje + Portugal).',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-schiereiland-scandinavisch-iberisch',
    label: 'Verwart Scandinavisch met Iberisch Schiereiland',
    module: 'Topo',
    description:
      'Leerling koppelt Noorwegen en Zweden (Scandinavisch Schiereiland, Noord-Europa) aan het Iberisch Schiereiland (Zuidwest-Europa).',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  // Q006 — IJsland als eilandland ver in de Atlantische Oceaan
  {
    id: 'topo.eu-eiland-ierland-vs-ijsland',
    label: 'Verwart Ierland (dichtbij vasteland) met IJsland (ver weg)',
    module: 'Topo',
    description:
      'Leerling kiest Ierland als het "verre" eilandland in de Atlantische Oceaan; Ierland ligt juist dicht bij Groot-Brittannië en het Europese vasteland, IJsland ligt halverwege Europa en Noord-Amerika.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-eiland-gb-vs-ijsland',
    label: 'Verwart Groot-Brittannië (dichtbij) met IJsland (ver weg)',
    module: 'Topo',
    description:
      'Leerling kiest Groot-Brittannië als het "verre" eilandland; Groot-Brittannië ligt vlak bij Frankrijk (het Kanaal is ~34 km breed), IJsland ligt veel verder in de Atlantische Oceaan.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
  {
    id: 'topo.eu-eiland-sicilie-als-land',
    label: 'Behandelt Sicilië als zelfstandig eilandland',
    module: 'Topo',
    description:
      'Leerling behandelt Sicilië als een zelfstandig eilandland; Sicilië is een eiland van Italië en ligt bovendien in de Middellandse Zee, niet in de Atlantische Oceaan.',
    typicalFamilies: ['TOPO-EU-LAND'],
  },
]
